import { createBrowserRouter } from 'react-router-dom';
import DashboardPage from '@/presentation/pages/DashboardPage';
import DriverDetailPage from '@/presentation/pages/DriverDetailPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/driver/:driverId',
    element: <DriverDetailPage />,
  },
]);

export default router;